import { ScreenUtils } from './../../utils/screen.utils';
import { Component, OnInit, Input } from '@angular/core';
import { Item } from 'src/app/shared/models/domain/item';
import { MaximumPaymentDeal } from 'src/app/shared/models/domain/maximumPaymentDeal';
import * as moment from 'moment';
import { Duration } from '../../shared/models/domain/duration';
import { AppSettingsService } from '../../services/app-settings/app-settings.service';
import { Currency } from '../../shared/models/currency';
import { PaymentPlan } from '../../shared/models/domain/payment-plan';
import { Price } from '../../shared/models/domain/price';
import {LoyaltyMode} from "@shopping-angular-components/loyalty";
@Component({
  selector: 'transfer-cluster',
  templateUrl: './transfer-cluster.component.html',
  styleUrls: ['./transfer-cluster.component.scss'],
})
export class TransferClusterComponent implements OnInit {
  @Input() item: Item;
  @Input() highHeavyHighlight: boolean;
  @Input() favoriteHighlight: boolean;  
  @Input() currencies: Currency[];
  @Input() loyaltyMode!: LoyaltyMode;
  @Input() order: number;
  @Input() cityGid: string;
  @Input() bimonetary: boolean;
  outwardTransferDate: string;
  returnTransferDate: string;
  hovered: boolean = false;
  providerFeatureEnabled: boolean = false;
  transferSupplierFeatureEnabled:boolean=false;

  priceboxData: {
    prices: Price[];
    currencies: Currency[];
    transferServiceType: string;
    coverage: string;
    paymentPlan: PaymentPlan;
    hash: string;
    hashFirstRoute?: string;
    hashSecondRoute?: string;
    trackingId: string;
    order: number
    payments:MaximumPaymentDeal[],
    bimonetary: boolean;

  };

  isMobile: boolean = ScreenUtils.isMobile();

  constructor(private appSettingsService: AppSettingsService) {}

  ngOnInit() {
    this.loadPriceboxConfig();
    this.setTransferDates();
    this.providerFeatureEnabled = this.appSettingsService.isProviderFeatureEnabled();
    this.transferSupplierFeatureEnabled = this.appSettingsService.isTransferSupplierFeatureEnabled();
  }

  private setTransferDates(): void {
    if (this.item.outwardSegment?.pickupDatetime) this.outwardTransferDate = this.getTransferDate(this.item.outwardSegment.pickupDatetime);
    if (this.item.returnSegment?.pickupDatetime) this.returnTransferDate = this.getTransferDate(this.item.returnSegment.pickupDatetime);
  };

  getTransferDate(date: Date): string {
    const site = this.appSettingsService.getSite();

    let dateFormat: string;
    let timeFormat: string;

    switch (site) {
        case 'US':
            dateFormat = 'MMM D';
            timeFormat = 'h:mm a';
            break;
        default:
            dateFormat = 'D MMM';
            timeFormat = 'HH:mm';
            break;
    }

    moment.locale(this.appSettingsService.getLocale());

    let noUTCDate = String(date).slice(0, -6);
    let newDate = moment(noUTCDate);

    const formattedDate = newDate.format(dateFormat);
    const formattedTime = newDate.format(timeFormat);

    return this.capitalizeFirstLetter(formattedDate) + ' - ' + formattedTime;
    
  }

  private capitalizeFirstLetter(text: string): string {
      return text.charAt(0).toUpperCase() + text.slice(1);
  }

  toggleHover() {
    this.hovered = !this.hovered;
  }

  private loadPriceboxConfig() {
    this.priceboxData = {
      prices: this.item.prices,
      transferServiceType: this.item.transferServiceType,
      currencies: this.currencies,
      coverage: this.item.coverage,
      paymentPlan: this.item.maximumPaymentPlan,
      hash: this.item.itemHash,
      hashFirstRoute: this.item.firstRouteItem?.itemHash,
      hashSecondRoute: this.item.secondRouteItem?.itemHash,
      trackingId: this.item.trackingId,
      order: this.order,
      payments: this.item.payments,
      bimonetary: this.bimonetary
    };
  }

  public getProduct(): string {
    return this.appSettingsService.getProduct();
  }

  public getFlow(): string {
    return this.appSettingsService.getFlow();
  }
}
